<template>
  <div>
    <div class="cple">
      <div class="cple_con">
        <h1 style="text-align: center">{{ t("币安顺风车 Token 简介") }}</h1>
        <h3>{{ t("概述") }}</h3>
        <div>
          <p>
            {{
              t(
                "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。"
              )
            }}
          </p>
        </div>
        <div>
          <h3>{{ t("核心参数") }}</h3>
          <ul>
            <li>{{ $t("代币标准：BEP-20（BSC）") }}</li>
            <li>{{ $t("最大供应：1,000M") }}</li>
            <li>{{ $t("启动即焚毁：432.46M（链上可查）") }}</li>
            <li>
              {{ $t("启动后剩余供应：567M") }}
            </li>
            <p>{{ $t("– 其中 200M 锁定用于行程挖矿奖励，非流通") }}</p>
            <p>{{ $t("– 其中 10M 锁定用于积分兑换等") }}</p>
          </ul>
        </div>
        <div>
          <h3>{{ t("产出与奖励机制") }}</h3>
          <ul>
            <li>{{ t("行程奖励=打卡点数量 × 单个打卡点奖励值") }}</li>
            <li>
              {{
                t("单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)")
              }}
            </li>
            <li>{{ t("个人奖励基数随全网总质押量动态调整") }}</li>
            <li>{{ t("全网单日奖励总上限：5,120 枚") }}</li>
          </ul>
        </div>

        <div>
          <h3>{{ $t("公平发射与官方参与") }}</h3>
          <ul>
            <li>{{ $t("零预售、零预留、零私募；全程公开透明") }}</li>
            <li>{{ $t("官方通过 four.meme 公平购入 210M 枚：") }}</li>
            <p>{{ $t("– 200M 枚锁入智能合约用于“行程挖矿”") }}</p>
            <p>{{ $t("– 10M 枚用于平台内积分兑换") }}</p>
            <!-- <p>{{ $t("– 8,888,888 枚用于社区活动与生态激励") }}</p> -->
            <li>
              {{
                $t("绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查")
              }}
            </li>
          </ul>
        </div>

        <!-- <div>
          <h3>{{ $t("团队长计划") }}</h3>
          <ul>
            <li>
              {{ $t("全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB") }}
            </li>
            <li>
              {{
                $t("预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰")
              }}
            </li>
            <p>{{ $t("公平发射分配（核心 60,000,000 枚）：") }}</p>
            <p>{{ $t("– 42,000,000 枚按投入比例分配") }}</p>
            <p>{{ $t("– 18,000,000 枚作为“团队长特殊贡献奖”") }}</p>
            <li>
              {{
                $t(
                  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权"
                )
              }}
            </li>
          </ul>
        </div>

        <div style="padding: 20px 0">
          <h3>{{ $t("团队长计划官方唯一地址：") }}</h3>
          <h3 style="word-break: break-all">
            0xbc74845Ea341F1203704b2CDcEDEE27060260605
          </h3>
        </div> -->

        <div>
          <h3>{{ $t("代币用途与价值") }}</h3>
          <ul>
            <li>{{ $t("出行激励：完成有效行程获得代币") }}</li>
            <li>
              {{ $t("权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等") }}
            </li>
            <li>
              {{
                $t(
                  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为"
                )
              }}
            </li>
          </ul>
        </div>

        <img src="../../assets/Frame 1321315165.png" class="cple_img" alt="" />
      </div>
    </div>

    <div class="cple_page" style="margin-top: -15px">
      <div class="cple_con">
        <h1>{{ t("币安顺风车 Token 简介") }}</h1>
        <h3>{{ t("概述") }}</h3>
        <div>
          <p>
            {{
              t(
                "币安顺风车是将区块链与绿色出行结合的应用型项目，用户通过顺风车、步行、公共交通等日常出行获取代币奖励，实现“边走边赚”。项目坚持公平发射与全链透明，强调长期激励与可持续的生态增长。"
              )
            }}
          </p>
        </div>
        <div>
          <h3>{{ t("核心参数") }}</h3>
          <ul>
            <li>{{ $t("代币标准：BEP-20（BSC）") }}</li>
            <li>{{ $t("最大供应：1,000M") }}</li>
            <li>{{ $t("启动即焚毁：432.46M（链上可查）") }}</li>
            <li>
              {{ $t("启动后剩余供应：567M") }}
            </li>
            <p>{{ $t("– 其中 200M 锁定用于行程挖矿奖励，非流通") }}</p>
            <p>{{ $t("– 其中 10M 锁定用于积分兑换等") }}</p>
          </ul>
        </div>
        <div>
          <h3>{{ t("产出与奖励机制") }}</h3>
          <ul>
            <li>{{ t("行程奖励=打卡点数量 × 单个打卡点奖励值") }}</li>
            <li>
              {{
                t("单个打卡点奖励值=个人奖励基数 × (个人质押数量÷10,000)^(1/4)")
              }}
            </li>
            <li>{{ t("个人奖励基数随全网总质押量动态调整") }}</li>
            <li>{{ t("全网单日奖励总上限：5,120 枚") }}</li>
          </ul>
        </div>

        <div>
          <h3>{{ $t("公平发射与官方参与") }}</h3>
          <ul>
            <li>{{ $t("零预售、零预留、零私募；全程公开透明") }}</li>
            <li>{{ $t("官方通过 four.meme 公平购入 210M 枚：") }}</li>
            <p>{{ $t("– 200M 枚锁入智能合约用于“行程挖矿”") }}</p>
            <p>{{ $t("– 10M 枚用于平台内积分兑换") }}</p>
            <!-- <p>{{ $t("– 8,888,888 枚用于社区活动与生态激励") }}</p> -->
            <li>
              {{
                $t("绑定曲线机制随购入自动抬价，官方与社区同价入场、链上可查")
              }}
            </li>
          </ul>
        </div>

        <!-- <div>
          <h3>{{ $t("团队长计划") }}</h3>
          <ul>
            <li>
              {{ $t("全球限量招募 100 位团队长：每人 0.7 BNB，总额 70 BNB") }}
            </li>
            <li>
              {{
                $t("预计可购约 7.6 亿枚，其中 7 亿枚将立即销毁；稀缺结构清晰")
              }}
            </li>
            <p>{{ $t("公平发射分配（核心 60,000,000 枚）：") }}</p>
            <p>{{ $t("– 42,000,000 枚按投入比例分配") }}</p>
            <p>{{ $t("– 18,000,000 枚作为“团队长特殊贡献奖”") }}</p>
            <li>
              {{
                $t(
                  "前 100 名获“车队老板”1 个月身份（不含任何分红），享平台内次数增益、赠送权限、专属徽章与活动优先权"
                )
              }}
            </li>
          </ul>
        </div>

        <div style="padding: 20px 0">
          <h3>{{ $t("团队长计划官方唯一地址：") }}</h3>
          <h3 style="word-break: break-all">
            0xbc74845Ea341F1203704b2CDcEDEE27060260605
          </h3>
        </div> -->

        <div>
          <h3>{{ $t("代币用途与价值") }}</h3>
          <ul>
            <li>{{ $t("出行激励：完成有效行程获得代币") }}</li>
            <li>
              {{ $t("权益与兑换：用于平台积分兑换、活动激励、NFT 权益配合等") }}
            </li>
            <li>
              {{
                $t(
                  "生态成长：围绕顺风出行的多场景应用，鼓励真实出行与绿色低碳行为"
                )
              }}
            </li>
          </ul>
        </div>
        <div class="cple_img">
          <img
            src="../../assets/Frame 1321315165.png"
            class="cple_img"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .cple {
    display: none;
  }

  .cple_page {
    display: block;
    width: 95%;
    margin: 80px auto;
    color: #fff;

    div,
    h3 {
      margin-bottom: 10px;
    }

    h1 {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    p {
      font-size: 15px;
      font-weight: 400;
      text-align: justify;
    }

    .cple_img {
      display: flex;
      justify-content: center;

      img {
        width: 343px;
        height: 171px;
        margin-top: 40px;
      }
    }

    li,
    p {
      color: #ffffffb2;
      margin-left: 30px;
      line-height: 25px;
    }
  }
}

@media (min-width: 601px) {
  .cple_page {
    display: none;
  }

  .cple {
    width: 100%;
    background: #000000;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    .cple_con {
      width: 1000px;
      padding-top: 60px;

      div,
      h3 {
        margin-bottom: 10px;
      }

      h1 {
        font-size: 40px;
        font-weight: 600;
        margin-bottom: 40px;
      }

      .cple_img {
        width: 1000px;
        height: 500px;
      }

      p {
        font-size: 18px;
        font-weight: 400;
        color: #ffffffb2;
      }

      li,
      p {
        color: #ffffffb2;
        margin-left: 30px;
        line-height: 25px;
      }
    }
  }
}
</style>

